<ng-container *ngIf="isLoaded()">
  <!-- Formularios en tarea o en modal sin wrapper -->
  <ng-container *ngIf="(task || windowHash); else templateWrapper">
    <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
  </ng-container>
  <ng-template #templateWrapper>
    <div class="wrapper wrapper-content BASEFORMINMODAL" *ngIf="!windowHash">
      <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
    </div>
  </ng-template>
  <ng-template #formTemplate>
    <formPlyca #formPlycaRef [formConfig]="formConfig" *ngIf="formConfig"></formPlyca>
  </ng-template>
</ng-container>

<ng-template #inboxesTemplate>
  <div class="col-12" *ngIf="model.replacedUser && model.replacedUser.inboxes">
    <p-table [value]="model.replacedUser.inboxes" [(selection)]="model.userInboxes" dataKey="identifier">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th style="width: 3rem" pSortableColumn="identifier">Id <p-sortIcon field="identifier"></p-sortIcon>
          </th>
          <th style="width: 30%" pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon>
          </th>
          <th pSortableColumn="description">Descripción <p-sortIcon field="description"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-inbox>
        <tr>
          <td>
            <p-tableCheckbox [value]="inbox"></p-tableCheckbox>
          </td>
          <td># {{inbox.identifier}}</td>
          <td>{{inbox.name}}</td>
          <td>{{inbox.description}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</ng-template>


<ng-template #profilesTemplate>
  <div class="col-12" *ngIf="model.replacedUser && model.replacedUser.listProfiles">
    <p-table [value]="model.replacedUser.listProfiles" [(selection)]="model.profiles" dataKey="identifier">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th style="width: 25%" pSortableColumn="application">Aplicación <p-sortIcon field="application"></p-sortIcon>
          </th>
          <th style="width: 3rem" pSortableColumn="identifier">Id <p-sortIcon field="identifier">
            </p-sortIcon>
          </th>
          <th pSortableColumn="description">Descripción <p-sortIcon field="description"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-profile>
        <tr>
          <td>
            <p-tableCheckbox [value]="profile"></p-tableCheckbox>
          </td>
          <td>{{profile.application}}</td>
          <td># {{profile.identifier}}</td>
          <td>{{profile.description}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</ng-template>